import { Button } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion';
import { fadeIn, staggerContainer } from '../../utils/motion';

const HireSection = ({ data }) => {

    const navigate = useNavigate()


    return (
        <div className='main-class'>
            <motion.div
                variants={staggerContainer}
                initial="hidden"
                whileInView="show"
                viewport={{ once: false }}>
                <div>
                    <h1
                        className='text-xl md:text-2xl font-bold text-center dark:text-white'
                    >
                        Why <span className='text-red-500'>{data.title}</span>
                    </h1>
                    <h1
                        className='text-xl md:text-2xl font-bold text-center dark:text-white'
                    >
                        <span className='text-red-500'>Developers</span> from CodeZone?
                    </h1>
                </div>
                <div className='my-8 px-2 md:mt-16 grid grid-cols-1 md:grid-cols-2 gap-4 items-center'>

                    <div>
                        <ul className='list-decimal space-y-2 px-5 md:px-0'>

                            {data.points.map((item, i) => (
                                <motion.div
                                    variants={fadeIn('right', 'tween', i + 0.1, 1.0)}
                                >
                                    <li key={i} className='text-xs md:text-base text-gray-700 dark:text-gray-300 italic'>{item}</li>
                                </motion.div>
                            ))}

                        </ul>
                        <div className=' mt-8  flex justify-center md:justify-start'>

                            <Button
                                onClick={() => navigate('/contact-us')}
                                variant='contained' color='error'
                                className='blob-btn'
                                size='large'
                                sx={{
                                    borderRadius: '30px',
                                    fontSize: '16px',
                                    backgroundColor: 'black !important',
                                    textTransform: 'none'
                                }}
                            >
                                Let us Call Now
                                <span class="blob-btn__inner">
                                    <span class="blob-btn__blobs">
                                        <span class="blob-btn__blob"></span>
                                        <span class="blob-btn__blob"></span>
                                        <span class="blob-btn__blob"></span>
                                        <span class="blob-btn__blob"></span>
                                    </span>
                                </span>

                            </Button>
                        </div>
                    </div>
                    <div >
                        <img src={data.img} alt="img"
                            className='object-contain cursor-pointer w-[80%] mx-auto md:w-full h-[400px]'
                            onClick={() => navigate('/pricing')}
                        />
                    </div>
                </div>
            </motion.div>
        </div>
    )
}

export default HireSection